(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1tTUb", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1143dd7f04075183$export$ffb0004e005737fa; }, function (v) { return $1143dd7f04075183$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1143dd7f04075183$export$34b9dba7ce09269b; }, function (v) { return $1143dd7f04075183$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1143dd7f04075183$export$25062201e9e25d76; }, function (v) { return $1143dd7f04075183$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1143dd7f04075183$export$ffb0004e005737fa;
var $1143dd7f04075183$export$34b9dba7ce09269b;
var $1143dd7f04075183$export$25062201e9e25d76;
"use strict";
var $1143dd7f04075183$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1143dd7f04075183$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1143dd7f04075183$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1143dd7f04075183$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1143dd7f04075183$export$ffb0004e005737fa = $1143dd7f04075183$var$REACT_FRAGMENT_TYPE;
$1143dd7f04075183$export$34b9dba7ce09269b = $1143dd7f04075183$var$jsxProd;
$1143dd7f04075183$export$25062201e9e25d76 = $1143dd7f04075183$var$jsxProd;

});

var $7ead0b1397a835ed$exports = {};
'use strict';

$7ead0b1397a835ed$exports = (parcelRequire("1tTUb"));


function $ba887f0904e69114$export$2e2bcd8739ae039() {
    const elFloatingBtnWrapper = document.querySelector('.webinar .fixed-button-wrapper');
    const elFormWrapper = document.querySelector('.webinar .form-wrapper');
    if (!(elFloatingBtnWrapper && elFormWrapper)) return;
    const elRegisterBtn = elFloatingBtnWrapper.querySelector('button');
    if (elRegisterBtn) elRegisterBtn.addEventListener('click', $ba887f0904e69114$var$scrollFormIntoView);
    const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: "0px",
        threshold: [
            0
        ]
    });
    observer.observe(elFormWrapper);
    function handleIntersection(entries, observer) {
        entries.forEach((entry)=>{
            if (adw.webinar_meta?.is_registered === true) {
                elFloatingBtnWrapper.classList.add('d-none');
                return;
            }
            if (entry.isIntersecting) {
                if (elFloatingBtnWrapper.classList.contains('d-flex')) {
                    if (typeof anime === 'function') anime({
                        targets: elFloatingBtnWrapper,
                        opacity: [
                            1,
                            0
                        ],
                        duration: 350,
                        easing: 'easeOutQuad',
                        onComplete: ()=>{
                            elFloatingBtnWrapper.classList.remove('d-flex');
                            elFloatingBtnWrapper.classList.add('d-none');
                        }
                    });
                    else {
                        elFloatingBtnWrapper.classList.remove('d-flex');
                        elFloatingBtnWrapper.classList.add('d-none');
                    }
                }
            } else if (elFloatingBtnWrapper.classList.contains('d-none') || elFloatingBtnWrapper.style.opacity < 1) {
                elFloatingBtnWrapper.classList.remove('d-none');
                elFloatingBtnWrapper.classList.add('d-flex');
                if (typeof anime === 'function') anime({
                    targets: elFloatingBtnWrapper,
                    opacity: [
                        0,
                        1
                    ],
                    duration: 350,
                    easing: 'easeOutQuad'
                });
            }
        });
    }
}
function $ba887f0904e69114$var$scrollFormIntoView() {
    $('html, body').animate({
        scrollTop: $('.webinar .form-wrapper').offset().top - 100
    }, 500, 'linear');
}



const $d31d5eedb2e4bc17$var$React = window.React;
function $d31d5eedb2e4bc17$export$908ab784d6e54235({ emailVal: emailVal, passwordVal: passwordVal, retry: retry = false }) {
    return new Promise((resolve, reject)=>{
        const payload = {
            identifiers: {
                email_address: emailVal
            },
            validators: {
                password: passwordVal
            }
        };
        if (retry) {
            payload.validators.password = "";
            payload.validators.legacy_password = passwordVal;
        }
        fetch("/blaize/login", {
            body: JSON.stringify(payload),
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then((res)=>{
            return res.json();
        }).then((data)=>{
            if (data.status && data.status !== 200) return reject({
                data: data,
                errorMessage: $d31d5eedb2e4bc17$export$e14eccf4d30c3f63[data.status]
            });
            else {
                $d31d5eedb2e4bc17$var$analyticEvents();
                return resolve(data);
            }
        }).catch((err)=>{
            console.error("Blaize Login Error", err);
            return reject(err);
        });
    });
}
const $d31d5eedb2e4bc17$export$94a94c25bfe2a6a8 = async (email)=>{
    return fetch("/blaize/users/reset", {
        "headers": {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        "body": JSON.stringify({
            "identifiers": {
                "email_address": email
            }
        }),
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
    });
};
const $d31d5eedb2e4bc17$export$12983a0dbd3c6db5 = async (email)=>{
    return fetch("/blaize/token-exchange", {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            identifiers: {
                email_address: email
            },
            delivery: {
                method: "email",
                destination: email,
                action: "login",
                redirect: window.location.href
            }
        }),
        method: "POST",
        mode: "cors",
        credentials: "include"
    });
};
const $d31d5eedb2e4bc17$export$e14eccf4d30c3f63 = {
    400: "Invalid email or password",
    401: "Invalid email or password",
    403: "Invalid email or password",
    404: "Invalid email or password",
    500: "There was an error logging in. Please try again later."
};
function $d31d5eedb2e4bc17$var$analyticEvents() {
    if (typeof PARSELY !== "undefined" && PARSELY?.conversions?.trackLinkClick) PARSELY.conversions.trackLinkClick("SiteLogin");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "Zephr",
        zeventCategory: "Login",
        zeventLabel: "Login Success"
    });
}
const $d31d5eedb2e4bc17$export$2852d657e2a7d685 = (ref, { stagger: stagger = false } = {})=>{
    $d31d5eedb2e4bc17$var$React.useEffect(()=>{
        if (typeof anime === "function" && ref?.current) {
            const animeOptions = {
                targets: ref.current,
                opacity: [
                    0,
                    1
                ],
                translateY: [
                    10,
                    0
                ],
                duration: 500,
                easing: "easeOutSine"
            };
            if (stagger) {
                animeOptions['targets'] = ref.current.children;
                animeOptions['delay'] = anime.stagger(100);
            }
            anime(animeOptions);
        }
    });
};


var $160fdeb028d2b801$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $160fdeb028d2b801$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$160fdeb028d2b801$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$160fdeb028d2b801$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$160fdeb028d2b801$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $160fdeb028d2b801$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $160fdeb028d2b801$var$DIGIT_REGEX = /^\d+$/, $160fdeb028d2b801$var$LEAD_DIGIT_REGEX = /^\d/, $160fdeb028d2b801$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $160fdeb028d2b801$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $160fdeb028d2b801$var$MAX_CACHE_SIZE = 512;
var $160fdeb028d2b801$var$pathCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE), $160fdeb028d2b801$var$setCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE), $160fdeb028d2b801$var$getCache = new $160fdeb028d2b801$var$Cache($160fdeb028d2b801$var$MAX_CACHE_SIZE);
var $160fdeb028d2b801$var$config;
$160fdeb028d2b801$exports = {
    Cache: $160fdeb028d2b801$var$Cache,
    split: $160fdeb028d2b801$var$split,
    normalizePath: $160fdeb028d2b801$var$normalizePath,
    setter: function(path) {
        var parts = $160fdeb028d2b801$var$normalizePath(path);
        return $160fdeb028d2b801$var$setCache.get(path) || $160fdeb028d2b801$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $160fdeb028d2b801$var$normalizePath(path);
        return $160fdeb028d2b801$var$getCache.get(path) || $160fdeb028d2b801$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($160fdeb028d2b801$var$isQuoted(part) || $160fdeb028d2b801$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $160fdeb028d2b801$var$forEach(Array.isArray(path) ? path : $160fdeb028d2b801$var$split(path), cb, thisArg);
    }
};
function $160fdeb028d2b801$var$normalizePath(path) {
    return $160fdeb028d2b801$var$pathCache.get(path) || $160fdeb028d2b801$var$pathCache.set(path, $160fdeb028d2b801$var$split(path).map(function(part) {
        return part.replace($160fdeb028d2b801$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $160fdeb028d2b801$var$split(path) {
    return path.match($160fdeb028d2b801$var$SPLIT_REGEX) || [
        ''
    ];
}
function $160fdeb028d2b801$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($160fdeb028d2b801$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $160fdeb028d2b801$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $160fdeb028d2b801$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $160fdeb028d2b801$var$hasLeadingNumber(part) {
    return part.match($160fdeb028d2b801$var$LEAD_DIGIT_REGEX) && !part.match($160fdeb028d2b801$var$DIGIT_REGEX);
}
function $160fdeb028d2b801$var$hasSpecialChars(part) {
    return $160fdeb028d2b801$var$SPEC_CHAR_REGEX.test(part);
}
function $160fdeb028d2b801$var$shouldBeQuoted(part) {
    return !$160fdeb028d2b801$var$isQuoted(part) && ($160fdeb028d2b801$var$hasLeadingNumber(part) || $160fdeb028d2b801$var$hasSpecialChars(part));
}


var $f5081849309927e9$exports = {};
const $f5081849309927e9$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $f5081849309927e9$var$words = (str)=>str.match($f5081849309927e9$var$reWords) || [];
const $f5081849309927e9$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $f5081849309927e9$var$join = (str, d)=>$f5081849309927e9$var$words(str).join(d).toLowerCase();
const $f5081849309927e9$var$camelCase = (str)=>$f5081849309927e9$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $f5081849309927e9$var$pascalCase = (str)=>$f5081849309927e9$var$upperFirst($f5081849309927e9$var$camelCase(str));
const $f5081849309927e9$var$snakeCase = (str)=>$f5081849309927e9$var$join(str, '_');
const $f5081849309927e9$var$kebabCase = (str)=>$f5081849309927e9$var$join(str, '-');
const $f5081849309927e9$var$sentenceCase = (str)=>$f5081849309927e9$var$upperFirst($f5081849309927e9$var$join(str, ' '));
const $f5081849309927e9$var$titleCase = (str)=>$f5081849309927e9$var$words(str).map($f5081849309927e9$var$upperFirst).join(' ');
$f5081849309927e9$exports = {
    words: $f5081849309927e9$var$words,
    upperFirst: $f5081849309927e9$var$upperFirst,
    camelCase: $f5081849309927e9$var$camelCase,
    pascalCase: $f5081849309927e9$var$pascalCase,
    snakeCase: $f5081849309927e9$var$snakeCase,
    kebabCase: $f5081849309927e9$var$kebabCase,
    sentenceCase: $f5081849309927e9$var$sentenceCase,
    titleCase: $f5081849309927e9$var$titleCase
};


var $d09f6ca57534047b$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $d09f6ca57534047b$exports = function(edges) {
    return $d09f6ca57534047b$var$toposort($d09f6ca57534047b$var$uniqueNodes(edges), edges);
};
$d09f6ca57534047b$exports.array = $d09f6ca57534047b$var$toposort;
function $d09f6ca57534047b$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $d09f6ca57534047b$var$makeOutgoingEdges(edges), nodesHash = $d09f6ca57534047b$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $d09f6ca57534047b$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $d09f6ca57534047b$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $d09f6ca57534047b$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $799ed2a39019e19a$var$toString = Object.prototype.toString;
const $799ed2a39019e19a$var$errorToString = Error.prototype.toString;
const $799ed2a39019e19a$var$regExpToString = RegExp.prototype.toString;
const $799ed2a39019e19a$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $799ed2a39019e19a$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $799ed2a39019e19a$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $799ed2a39019e19a$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $799ed2a39019e19a$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $799ed2a39019e19a$var$symbolToString.call(val).replace($799ed2a39019e19a$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $799ed2a39019e19a$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $799ed2a39019e19a$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $799ed2a39019e19a$var$regExpToString.call(val);
    return null;
}
function $799ed2a39019e19a$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $799ed2a39019e19a$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $799ed2a39019e19a$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $799ed2a39019e19a$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $799ed2a39019e19a$var$_Symbol$toStringTag, $799ed2a39019e19a$var$_Symbol$hasInstance, $799ed2a39019e19a$var$_Symbol$toStringTag2;
let $799ed2a39019e19a$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$799ed2a39019e19a$var$_Symbol$toStringTag = Symbol.toStringTag;
class $799ed2a39019e19a$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$799ed2a39019e19a$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $799ed2a39019e19a$var$toArray(errorOrErrors).forEach((err)=>{
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$799ed2a39019e19a$var$_Symbol$hasInstance = Symbol.hasInstance;
$799ed2a39019e19a$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $799ed2a39019e19a$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($799ed2a39019e19a$var$strReg, (_, key)=>$799ed2a39019e19a$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $799ed2a39019e19a$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$799ed2a39019e19a$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $799ed2a39019e19a$export$2191b9da168c6cf0);
    }
    static [$799ed2a39019e19a$var$_Symbol$hasInstance](inst) {
        return $799ed2a39019e19a$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $799ed2a39019e19a$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$799ed2a39019e19a$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$799ed2a39019e19a$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$799ed2a39019e19a$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $799ed2a39019e19a$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $799ed2a39019e19a$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $799ed2a39019e19a$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $799ed2a39019e19a$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $799ed2a39019e19a$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $799ed2a39019e19a$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $799ed2a39019e19a$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$799ed2a39019e19a$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$799ed2a39019e19a$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $799ed2a39019e19a$export$2191b9da168c6cf0.formatError($799ed2a39019e19a$var$mixed.notType, params);
    }
};
var $799ed2a39019e19a$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $799ed2a39019e19a$var$mixed,
    string: $799ed2a39019e19a$var$string,
    number: $799ed2a39019e19a$var$number,
    date: $799ed2a39019e19a$var$date,
    object: $799ed2a39019e19a$var$object,
    array: $799ed2a39019e19a$var$array,
    boolean: $799ed2a39019e19a$var$boolean,
    tuple: $799ed2a39019e19a$var$tuple
});
const $799ed2a39019e19a$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $799ed2a39019e19a$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $799ed2a39019e19a$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$799ed2a39019e19a$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $799ed2a39019e19a$var$prefixes = {
    context: '$',
    value: '.'
};
function $799ed2a39019e19a$export$eff4d24c3ff7876e(key, options) {
    return new $799ed2a39019e19a$var$Reference(key, options);
}
class $799ed2a39019e19a$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $799ed2a39019e19a$var$prefixes.context;
        this.isValue = this.key[0] === $799ed2a39019e19a$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $799ed2a39019e19a$var$prefixes.context : this.isValue ? $799ed2a39019e19a$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $160fdeb028d2b801$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$799ed2a39019e19a$var$Reference.prototype.__isYupRef = true;
const $799ed2a39019e19a$var$isAbsent = (value)=>value == null;
function $799ed2a39019e19a$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $799ed2a39019e19a$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $799ed2a39019e19a$export$2191b9da168c6cf0($799ed2a39019e19a$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $799ed2a39019e19a$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $799ed2a39019e19a$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $160fdeb028d2b801$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $799ed2a39019e19a$export$cfedb76369cc7782(obj, path, value, context) {
    return $799ed2a39019e19a$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $799ed2a39019e19a$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($799ed2a39019e19a$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $799ed2a39019e19a$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $799ed2a39019e19a$var$clone(src, seen = new Map()) {
    if ($799ed2a39019e19a$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $799ed2a39019e19a$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $799ed2a39019e19a$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($799ed2a39019e19a$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $799ed2a39019e19a$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $799ed2a39019e19a$var$ReferenceSet();
        this._blacklist = new $799ed2a39019e19a$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($799ed2a39019e19a$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $799ed2a39019e19a$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $799ed2a39019e19a$var$isAbsent(result)) return result;
            let formattedValue = $799ed2a39019e19a$export$5790025c6e6c2ba6(value);
            let formattedResult = $799ed2a39019e19a$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $799ed2a39019e19a$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $799ed2a39019e19a$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $799ed2a39019e19a$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $799ed2a39019e19a$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $799ed2a39019e19a$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $799ed2a39019e19a$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $799ed2a39019e19a$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $799ed2a39019e19a$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $799ed2a39019e19a$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $799ed2a39019e19a$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $799ed2a39019e19a$var$toArray(keys).map((key)=>new $799ed2a39019e19a$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $799ed2a39019e19a$var$Condition(deps, options) : $799ed2a39019e19a$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $799ed2a39019e19a$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $799ed2a39019e19a$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $799ed2a39019e19a$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $799ed2a39019e19a$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $799ed2a39019e19a$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$799ed2a39019e19a$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$799ed2a39019e19a$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $799ed2a39019e19a$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$799ed2a39019e19a$export$19342e026b58ebb7.prototype[alias] = $799ed2a39019e19a$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$799ed2a39019e19a$export$19342e026b58ebb7.prototype[alias] = $799ed2a39019e19a$export$19342e026b58ebb7.prototype.notOneOf;
const $799ed2a39019e19a$var$returnsTrue = ()=>true;
function $799ed2a39019e19a$export$9b30b6294c1449a8(spec) {
    return new $799ed2a39019e19a$export$1e88358c94ddec71(spec);
}
class $799ed2a39019e19a$export$1e88358c94ddec71 extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $799ed2a39019e19a$var$returnsTrue
        }, spec));
    }
}
$799ed2a39019e19a$export$9b30b6294c1449a8.prototype = $799ed2a39019e19a$export$1e88358c94ddec71.prototype;
function $799ed2a39019e19a$export$87b259aa03e3d267() {
    return new $799ed2a39019e19a$export$c7980688f11e1f49();
}
class $799ed2a39019e19a$export$c7980688f11e1f49 extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $799ed2a39019e19a$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $799ed2a39019e19a$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $799ed2a39019e19a$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $799ed2a39019e19a$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$799ed2a39019e19a$export$87b259aa03e3d267.prototype = $799ed2a39019e19a$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $799ed2a39019e19a$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $799ed2a39019e19a$var$parseIsoDate(date) {
    const struct = $799ed2a39019e19a$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $799ed2a39019e19a$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $799ed2a39019e19a$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $799ed2a39019e19a$var$toNumber(regexResult[1]),
        month: $799ed2a39019e19a$var$toNumber(regexResult[2], 1) - 1,
        day: $799ed2a39019e19a$var$toNumber(regexResult[3], 1),
        hour: $799ed2a39019e19a$var$toNumber(regexResult[4]),
        minute: $799ed2a39019e19a$var$toNumber(regexResult[5]),
        second: $799ed2a39019e19a$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $799ed2a39019e19a$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $799ed2a39019e19a$var$toNumber(regexResult[10]),
        minuteOffset: $799ed2a39019e19a$var$toNumber(regexResult[11])
    };
}
function $799ed2a39019e19a$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $799ed2a39019e19a$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $799ed2a39019e19a$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $799ed2a39019e19a$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $799ed2a39019e19a$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $799ed2a39019e19a$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $799ed2a39019e19a$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $799ed2a39019e19a$var$rIsoDateTime = new RegExp(`${$799ed2a39019e19a$var$yearMonthDay}T${$799ed2a39019e19a$var$hourMinuteSecond}(\\.\\d+)?${$799ed2a39019e19a$var$zOrOffset}$`);
let $799ed2a39019e19a$var$isTrimmed = (value)=>$799ed2a39019e19a$var$isAbsent(value) || value === value.trim();
let $799ed2a39019e19a$var$objStringTag = ({}).toString();
function $799ed2a39019e19a$export$22b082955e083ec3() {
    return new $799ed2a39019e19a$export$49bf8b2ede5138eb();
}
class $799ed2a39019e19a$export$49bf8b2ede5138eb extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $799ed2a39019e19a$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $799ed2a39019e19a$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $799ed2a39019e19a$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $799ed2a39019e19a$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $799ed2a39019e19a$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $799ed2a39019e19a$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $799ed2a39019e19a$var$string.email) {
        return this.matches($799ed2a39019e19a$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $799ed2a39019e19a$var$string.url) {
        return this.matches($799ed2a39019e19a$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $799ed2a39019e19a$var$string.uuid) {
        return this.matches($799ed2a39019e19a$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($799ed2a39019e19a$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $799ed2a39019e19a$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $799ed2a39019e19a$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $799ed2a39019e19a$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $799ed2a39019e19a$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $799ed2a39019e19a$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $799ed2a39019e19a$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $799ed2a39019e19a$var$isTrimmed
        });
    }
    lowercase(message = $799ed2a39019e19a$var$string.lowercase) {
        return this.transform((value)=>!$799ed2a39019e19a$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$799ed2a39019e19a$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $799ed2a39019e19a$var$string.uppercase) {
        return this.transform((value)=>!$799ed2a39019e19a$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$799ed2a39019e19a$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$799ed2a39019e19a$export$22b082955e083ec3.prototype = $799ed2a39019e19a$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $799ed2a39019e19a$var$isNaN$1 = (value)=>value != +value;
function $799ed2a39019e19a$export$98e628dec113755e() {
    return new $799ed2a39019e19a$export$f192ec5e9228ab19();
}
class $799ed2a39019e19a$export$f192ec5e9228ab19 extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$799ed2a39019e19a$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $799ed2a39019e19a$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $799ed2a39019e19a$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $799ed2a39019e19a$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $799ed2a39019e19a$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $799ed2a39019e19a$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $799ed2a39019e19a$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $799ed2a39019e19a$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$799ed2a39019e19a$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$799ed2a39019e19a$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$799ed2a39019e19a$export$98e628dec113755e.prototype = $799ed2a39019e19a$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $799ed2a39019e19a$var$invalidDate = new Date('');
let $799ed2a39019e19a$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $799ed2a39019e19a$export$324d90190a8b822a() {
    return new $799ed2a39019e19a$export$18ec3cc5a157503f();
}
class $799ed2a39019e19a$export$18ec3cc5a157503f extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $799ed2a39019e19a$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $799ed2a39019e19a$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $799ed2a39019e19a$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$799ed2a39019e19a$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $799ed2a39019e19a$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $799ed2a39019e19a$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$799ed2a39019e19a$export$18ec3cc5a157503f.INVALID_DATE = $799ed2a39019e19a$var$invalidDate;
$799ed2a39019e19a$export$324d90190a8b822a.prototype = $799ed2a39019e19a$export$18ec3cc5a157503f.prototype;
$799ed2a39019e19a$export$324d90190a8b822a.INVALID_DATE = $799ed2a39019e19a$var$invalidDate;
// @ts-expect-error
function $799ed2a39019e19a$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $160fdeb028d2b801$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($799ed2a39019e19a$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($799ed2a39019e19a$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($d09f6ca57534047b$exports))).array(Array.from(nodes), edges).reverse();
}
function $799ed2a39019e19a$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $799ed2a39019e19a$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $799ed2a39019e19a$var$findIndex(keys, a) - $799ed2a39019e19a$var$findIndex(keys, b);
    };
}
const $799ed2a39019e19a$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $799ed2a39019e19a$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $799ed2a39019e19a$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $799ed2a39019e19a$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($799ed2a39019e19a$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $799ed2a39019e19a$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $160fdeb028d2b801$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $160fdeb028d2b801$exports.getter)((0, $160fdeb028d2b801$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $799ed2a39019e19a$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $799ed2a39019e19a$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $799ed2a39019e19a$var$defaultSort = $799ed2a39019e19a$var$sortByKeyOrder([]);
function $799ed2a39019e19a$export$be5493f9613cbbe(spec) {
    return new $799ed2a39019e19a$export$18b4fc70ec7eccf8(spec);
}
class $799ed2a39019e19a$export$18b4fc70ec7eccf8 extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $799ed2a39019e19a$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $799ed2a39019e19a$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $799ed2a39019e19a$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$799ed2a39019e19a$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $799ed2a39019e19a$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $799ed2a39019e19a$var$sortFields(shape, excludedEdges);
        next._sortErrors = $799ed2a39019e19a$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $799ed2a39019e19a$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $160fdeb028d2b801$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($799ed2a39019e19a$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($799ed2a39019e19a$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $799ed2a39019e19a$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $799ed2a39019e19a$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $799ed2a39019e19a$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $799ed2a39019e19a$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $799ed2a39019e19a$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $f5081849309927e9$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $f5081849309927e9$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $f5081849309927e9$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$799ed2a39019e19a$export$be5493f9613cbbe.prototype = $799ed2a39019e19a$export$18b4fc70ec7eccf8.prototype;
function $799ed2a39019e19a$export$2f23118c22fb2630(type) {
    return new $799ed2a39019e19a$export$4347112b8447a7d(type);
}
class $799ed2a39019e19a$export$4347112b8447a7d extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($799ed2a39019e19a$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$799ed2a39019e19a$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $799ed2a39019e19a$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $799ed2a39019e19a$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $799ed2a39019e19a$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $799ed2a39019e19a$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$799ed2a39019e19a$export$2f23118c22fb2630.prototype = $799ed2a39019e19a$export$4347112b8447a7d.prototype;
// @ts-ignore
function $799ed2a39019e19a$export$65e3907585753458(schemas) {
    return new $799ed2a39019e19a$export$411c3b3687e8ecc8(schemas);
}
class $799ed2a39019e19a$export$411c3b3687e8ecc8 extends $799ed2a39019e19a$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($799ed2a39019e19a$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$799ed2a39019e19a$export$65e3907585753458.prototype = $799ed2a39019e19a$export$411c3b3687e8ecc8.prototype;
function $799ed2a39019e19a$export$488013bae63b21da(builder) {
    return new $799ed2a39019e19a$export$71117d144d3091c9(builder);
}
function $799ed2a39019e19a$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $799ed2a39019e19a$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$799ed2a39019e19a$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $799ed2a39019e19a$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $799ed2a39019e19a$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $799ed2a39019e19a$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($799ed2a39019e19a$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $799ed2a39019e19a$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $799ed2a39019e19a$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $799ed2a39019e19a$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$799ed2a39019e19a$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


const $b848a69549ac2b75$export$2a4885432b9ae89 = (0, $799ed2a39019e19a$export$22b082955e083ec3)().email("Invalid email").required("Email is required");
const $b848a69549ac2b75$export$99fb6dde800e2bc4 = (0, $799ed2a39019e19a$export$22b082955e083ec3)().required("Password is required");
const $b848a69549ac2b75$export$616de432c1e57d03 = (0, $799ed2a39019e19a$export$be5493f9613cbbe)({
    email: $b848a69549ac2b75$export$2a4885432b9ae89,
    password: $b848a69549ac2b75$export$99fb6dde800e2bc4
});


/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $d9010ee870d463b5$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $d9010ee870d463b5$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $d9010ee870d463b5$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}


const $70a4a67c53cab669$var$React = window.React;
function $70a4a67c53cab669$export$407cecc2d815cd74() {
    const elForm = document.querySelector('#convertr-form');
    if (elForm) elForm.remove();
    const elH2 = document.querySelector('.form-wrapper h2');
    if (elH2) elH2.remove();
}
function $70a4a67c53cab669$export$bdc7c5cd37699390() {
    const elFormDigioh = document.getElementById('digioh-form-wrapper');
    if (elFormDigioh) elFormDigioh.remove();
    const elForm = document.querySelector('#convertr-form');
    if (elForm) elForm.remove();
}
function $70a4a67c53cab669$export$eae3ab9a391c6ffd(v) {
    const match = DIGIOH_LIGHTBOX_CONDITIONS.find((item)=>{
        if (!item.conditions || !Array.isArray(item.conditions)) return false;
        return item.conditions.some((group)=>Array.isArray(group) && group.some((cond)=>cond.v && cond.v.includes(v)));
    });
    if (!match) return null;
    const guid = match.lightbox_guid;
    const name = window.DIGIOH_LIGHTBOX_NAMES[guid] || null;
    return name;
}
function $70a4a67c53cab669$export$2e2bcd8739ae039() {
    if (adw?.webinar_meta?.registration_url) return "aw_webinar_" + btoa(adw.webinar_meta.registration_url);
    return null;
}
function $70a4a67c53cab669$export$5303cf8b8f096deb(container) {
    let elLoading = null;
    if (container) elLoading = container.querySelector('[data-loading]');
    else elLoading = document.querySelectorAll('#convertr-form [data-loading]');
    if (elLoading) elLoading.remove();
}
function $70a4a67c53cab669$export$82de835bb8638b43({ fieldValues: fieldValues, email: email, password: password }) {
    return new Promise(async (resolve, reject1)=>{
        let user = {
            identifiers: {
                email_address: email
            },
            attributes: fieldValues
        };
        if (password) user['validators'] = {
            password: password
        };
        try {
            const response = await fetch(`${window.location.origin}/blaize/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(user)
            });
            const data = response.json();
            return resolve(data);
        } catch (err) {
            return reject1(err);
        }
    });
}
async function $70a4a67c53cab669$export$d2da082481fe41f({ email: email, action: action = 'login' }) {
    try {
        const response = await fetch(`${window.location.origin}/blaize/token-exchange`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                "identifiers": {
                    "email_address": email
                },
                "delivery": {
                    "method": "email",
                    "destination": email,
                    "action": action,
                    "redirect": `/${window.location.href}`
                }
            })
        });
    } catch (err) {
        return reject(err);
    }
}
function $70a4a67c53cab669$export$c7250a15240b561b({ firstName: firstName } = {}) {
    if (typeof updateUserStateInNav === 'function' && firstName) updateUserStateInNav({
        name: firstName,
        isLoggedIn: true,
        isSubscribed: false,
        isRegistered: true,
        isEmailVerified: false
    });
}
const $70a4a67c53cab669$export$3a09f6f0b9fa7cb9 = (email = '', unset = false)=>{
    const localStorageKey = $70a4a67c53cab669$export$2e2bcd8739ae039();
    if (unset) localStorage.removeItem(localStorageKey);
    else localStorage.setItem(localStorageKey, JSON.stringify(btoa(email)));
};
const $70a4a67c53cab669$export$cb7776dcba1aa2 = ()=>{
    const localStorageKey = $70a4a67c53cab669$export$2e2bcd8739ae039();
    if (!localStorageKey) return false;
    const localStorageValue = localStorage.getItem(localStorageKey);
    if (localStorageValue) return JSON.parse(atob(localStorageValue));
    return false;
};
const $70a4a67c53cab669$export$3872c79dafc63da2 = (email)=>{
    if (typeof Cookies === 'function') {
        const cookieKey = $70a4a67c53cab669$export$2e2bcd8739ae039();
        if (!cookieKey) throw new Error('No cookie key available');
        Cookies.set(cookieKey, JSON.stringify(btoa(email)), {
            expires: 30
        });
    }
};
const $70a4a67c53cab669$export$4555dbaf6c217ba2 = ()=>{
    if (typeof Cookies === 'function') {
        const cookieKey = $70a4a67c53cab669$export$2e2bcd8739ae039();
        if (!cookieKey) throw new Error('No cookie key available');
        const cookieValue = Cookies.get(cookieKey);
        if (cookieValue) return atob(JSON.parse(cookieValue));
    }
    return false;
};
const $70a4a67c53cab669$export$c52aecb04e8f29cd = ()=>{
    return $70a4a67c53cab669$export$4555dbaf6c217ba2() || $70a4a67c53cab669$export$cb7776dcba1aa2();
};
const $70a4a67c53cab669$export$680d6313e5f8249a = (email = '')=>{
    $70a4a67c53cab669$export$3872c79dafc63da2(email);
    $70a4a67c53cab669$export$3a09f6f0b9fa7cb9(email);
    adw.webinar_meta.is_registered = true;
};
const $70a4a67c53cab669$export$14113472834e2950 = function(args, postId = null) {
    return new Promise((resolve, reject1)=>{
        const params = new URLSearchParams();
        for(const key in args)params.set(key, args[key]);
        // Add post ID to params if available
        if (postId) params.set('post_id', postId);
        const queryString = params.toString();
        // If registration_url is set in post meta, use the new default registration flow
        const registrationUrl = adw?.webinar_meta?.registration_url;
        if (registrationUrl) {
            const { fname: fname, lname: lname, email: email, firstName: firstName, lastName: lastName, emailAddress: emailAddress, ...additionalFields } = args;
            const registrationPayload = {
                firstName: firstName || fname || '',
                lastName: lastName || lname || '',
                emailAddress: emailAddress || email || '',
                ...additionalFields
            };
            const requestPayload = {
                ...registrationPayload,
                post_id: Number(postId || adw?.post?.id || 0),
                registration_url: registrationUrl
            };
            fetch(`${window.location.origin}/wp-json/adw_webinar_registration/v1/registration/`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestPayload)
            }).then((response)=>{
                return response?.json?.() || {};
            }).then((response)=>{
                return resolve(response);
            }).catch((error)=>reject1(error));
        } else // To-Do: Remove this legacy registration flow after confirming all clients have updated to the new flow that uses the registration_url post meta field
        fetch(`${window.location.origin}/wp-json/adw-webcasts/v1/register_user/?${queryString}`).then((response)=>{
            if (response.status !== 200) return reject1();
            return response.json();
        }).then((response)=>resolve(response)).catch((error)=>reject1(error));
        // Send data to BigQuery
        $70a4a67c53cab669$var$sendRegistrationDataToBigQuery(queryString);
    });
};
function $70a4a67c53cab669$var$isProductionDomain() {
    const host = window.location.host;
    return host === "www.adweek.com" || host === "adweek.com";
}
function $70a4a67c53cab669$var$buildIterableEndpoint(path) {
    const base = $70a4a67c53cab669$var$isProductionDomain() ? "https://audience.adweek.com" : "https://audience-develop.adweek.com";
    return base + path;
}
const $70a4a67c53cab669$export$26105d6ea9faa05f = function(args) {
    const endpoint = $70a4a67c53cab669$var$buildIterableEndpoint('/wp-json/adw-zephr/v2/webinar-registration-to-iterable');
    if (!endpoint) throw new Error('No iterable endpoint');
    return new Promise((resolve, reject1)=>{
        fetch(endpoint, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(args)
        }).then((response)=>{
            if (response.status !== 200) return reject1();
            return response.json();
        }).then((response)=>resolve(response)).catch((error)=>reject1(error));
    });
};
function $70a4a67c53cab669$var$sendRegistrationDataToBigQuery(queryString) {
    if (!adw?.webinar_meta?.bigquery_webhook) return;
    return fetch(`${adw.webinar_meta.bigquery_webhook}/?${queryString}`).then((response)=>{
        if (response.status !== 200) return reject();
        console.log(response);
    }).catch((error)=>console.error('Error in BigQuery Webhook', error));
}
const $70a4a67c53cab669$export$f2672416beab0424 = ({ email: email })=>{
    if (!email) return ``;
    if (adw?.webinar_meta?.registration_url) return `${adw.webinar_meta.auto_join_url}?emailAddress=${email}`;
    // To-Do: Update this function to use the registration_url post meta field for generating the webinar entry link if it's set, and remove legacy support for the old entry link format that relies on the event_id query param after confirming all clients have updated to the new flow 
    return `https://event.webcasts.com/starthere.jsp?ei=${adw.webinar_meta.event_id}&email=${email}`;
};
const $70a4a67c53cab669$export$2852d657e2a7d685 = (ref, options = {})=>{
    $70a4a67c53cab669$var$React.useEffect(()=>{
        if (typeof anime === 'function' && ref?.current !== 'undefined') anime({
            targets: ref.current,
            opacity: [
                0,
                1
            ],
            translateY: [
                10,
                0
            ],
            duration: 500,
            easing: 'easeOutQuad',
            ...options,
            complete: function(anim) {}
        });
    }, [
        ref
    ]);
};
const $70a4a67c53cab669$export$e06aeb8d379fb85b = (key, val)=>{
    const getValWithBoolCheck = (val)=>{
        if (val === 'true') val = true;
        else if (val === 'false') val = false;
        return val;
    };
    const setClientState = (val)=>{
        localStorage.setItem(key, val);
    };
    const valFromLocalStorage = JSON.parse(localStorage.getItem(key));
    let valForState = null;
    if (valFromLocalStorage) valForState = getValWithBoolCheck(valFromLocalStorage);
    else valForState = val;
    const [state, setState] = $70a4a67c53cab669$var$React.useState(valForState);
    $70a4a67c53cab669$var$React.useEffect(()=>{
        localStorage.setItem(key, JSON.stringify(getValWithBoolCheck(state)));
    }, [
        state
    ]);
    return [
        state,
        setState,
        setClientState
    ];
};
const $70a4a67c53cab669$export$e01218ac5c35c80a = (ref)=>{
    $70a4a67c53cab669$var$React.useEffect(()=>{
        if (ref.current) {
            const elHeight = ref.current.getBoundingClientRect().height;
            if (typeof elHeight === 'number' && elHeight > 0) ref.current.style.minHeight = `${elHeight}px`;
        }
    }, [
        ref
    ]);
};


const { useEffect: $4b5ae0f691c28a51$var$useEffect, useState: $4b5ae0f691c28a51$var$useState, useRef: $4b5ae0f691c28a51$var$useRef } = window.React;
const $4b5ae0f691c28a51$export$1f58f750f20f344b = ({ rounded: rounded = true, isLoading: isLoading, setIsLoading: setIsLoading, LoginTitleComponent: LoginTitleComponent = null } = {})=>{
    const [credErrMessage, setCredErrMessage] = $4b5ae0f691c28a51$var$useState(null);
    const [passwordResetMessage, setPasswordResetMessage] = $4b5ae0f691c28a51$var$useState(null);
    const [magicLinkMessage, setMagicLinkMessage] = $4b5ae0f691c28a51$var$useState(null);
    const [usePassword, setUsePassword] = $4b5ae0f691c28a51$var$useState(false);
    const refEmail = $4b5ae0f691c28a51$var$useRef();
    const refPassword = $4b5ae0f691c28a51$var$useRef();
    const refForm = $4b5ae0f691c28a51$var$useRef();
    const refFormFieldWrapper = $4b5ae0f691c28a51$var$useRef();
    const [canLogin, setCanLogin] = $4b5ae0f691c28a51$var$useState(false);
    const [canResetPasswordOrMagicLink, setCanResetPasswordOrMagicLink] = $4b5ae0f691c28a51$var$useState(false);
    const [isPasswordResetMode, setIsPasswordResetMode] = $4b5ae0f691c28a51$var$useState(false);
    const [isSendingMagicLink, setIsSendingMagicLink] = $4b5ae0f691c28a51$var$useState(false);
    const unsetMinHeightAndWidth = (refForm)=>{
        if (refForm.current) {
            refForm.current.parentElement.style.minHeight = `initial`;
            refForm.current.parentElement.style.minWidth = `initial`;
        }
    };
    window.addEventListener('resize', (0, $d9010ee870d463b5$export$de363e709c412c8a)(200, ()=>{
        unsetMinHeightAndWidth(refForm);
    }));
    const startPasswordResetProcess = (e)=>{
        e?.preventDefault();
        try {
            // Setting minimum height so that form maintains same height during UI changes in form content.
            const formMinHeight = refForm.current.parentElement.getBoundingClientRect().height;
            const formMinWidth = refForm.current.parentElement.getBoundingClientRect().width;
            refForm.current.parentElement.style.minHeight = `${formMinHeight}px`;
            refForm.current.parentElement.style.minWidth = `${formMinWidth}px`;
        } catch (err) {
            console.log('Error setting height', err);
        }
        setIsPasswordResetMode(true);
    };
    const handleFormChange = async (e)=>{
        const elPasswordInput = refForm.current?.querySelector('input[name="password"]');
        const elEmailInput = refForm.current?.querySelector('input[name="email"]');
        try {
            await (0, $b848a69549ac2b75$export$616de432c1e57d03).validate({
                email: elEmailInput.value,
                password: elPasswordInput.value
            });
            setCanLogin(true);
        } catch (err) {
            setCanLogin(false);
        }
        try {
            const emailIsValid = await (0, $b848a69549ac2b75$export$2a4885432b9ae89).isValid(elEmailInput.value);
            setCanResetPasswordOrMagicLink(emailIsValid);
        } catch (err) {
            setCanResetPasswordOrMagicLink(false);
        }
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setMinHeightSubmitBtn();
        setMagicLinkMessage(null);
        setCredErrMessage(null);
        const elPasswordInput = e.target.querySelector('input[name="password"]');
        const elEmailInput = e.target.querySelector('input[name="email"]');
        try {
            await (0, $b848a69549ac2b75$export$616de432c1e57d03).validate({
                email: elEmailInput.value,
                password: elPasswordInput.value
            });
            setIsLoading(true);
            try {
                const loginRes = await (0, $d31d5eedb2e4bc17$export$908ab784d6e54235)({
                    emailVal: elEmailInput.value,
                    passwordVal: elPasswordInput.value
                });
                handleRes({
                    res: loginRes
                });
            } catch (err) {
                console.warn('First Login attempt failed', err);
                try {
                    const loginResRetry = await (0, $d31d5eedb2e4bc17$export$908ab784d6e54235)({
                        emailVal: elEmailInput.value,
                        passwordVal: elPasswordInput.value,
                        retry: true
                    });
                    handleRes({
                        res: loginResRetry,
                        retry: true
                    });
                } catch (errRetry) {
                    console.warn('Second Login attempt for legacy password failed', errRetry);
                    handleRes({
                        res: errRetry
                    });
                }
            }
        } catch (err) {
            setCredErrMessage('Check input fields');
        }
    };
    const handleRes = ({ res: res, retry: retry = false, cb: cb })=>{
        console.log('Login response: ', res);
        if (res && !res.status) console.warn('No status in response.', res);
        if (res && res.tracking_id) handleSuccess({
            res: res,
            cb: cb
        });
        else handleErrorMessages(res);
    };
    const handleSuccess = ({ cb: cb })=>{
        if (typeof cb === 'function') {
            setIsLoading(false);
            cb();
        } else window.location.reload();
    };
    const handleErrorMessages = (err)=>{
        if (err && err.errorMessage) {
            console.log('err.errorMessage', err.errorMessage);
            setCredErrMessage(err.errorMessage);
        } else setCredErrMessage('Something went wrong. Try again later.');
        setIsLoading(false);
    };
    const schemas = {
        email: (0, $b848a69549ac2b75$export$2a4885432b9ae89),
        password: (0, $b848a69549ac2b75$export$99fb6dde800e2bc4)
    };
    const handleInputFieldValidation = async (e)=>{
        const elInlineError = e.target.parentElement.querySelector(`[data-field-name="${e.target.name}"]`);
        if (!elInlineError) return;
        try {
            const validation = await schemas[e.target.name].validate(e.target.value);
            if (elInlineError) elInlineError.innerHTML = '';
        } catch (err) {
            if (elInlineError) elInlineError.innerHTML = err?.errors?.[0] || '';
        }
    };
    const refSubmit = React.useRef();
    const setMinHeightSubmitBtn = ()=>{
        const submitBtnHeight = refSubmit?.current?.getBoundingClientRect?.().height;
        if (submitBtnHeight && submitBtnHeight > 0) refSubmit.current.style.minHeight = `${submitBtnHeight}px`;
    };
    const handleMagicLinkRequest = async ()=>{
        setIsSendingMagicLink(true);
        setMagicLinkMessage(null);
        try {
            const res = await (0, $d31d5eedb2e4bc17$export$12983a0dbd3c6db5)(refEmail.current.value);
            const resJson = await res.json();
            setIsSendingMagicLink(false);
            setMagicLinkMessage(resJson?.message ? resJson.message : 'Could not request Magic Link. Try again later.');
        } catch (err) {
            setMagicLinkMessage('Could not request Magic Link. Try again later.');
            setIsSendingMagicLink(false);
            console.warn('Error requesting magic link', err);
        }
    };
    const handlePasswordReset = async ()=>{
        setIsLoading(true);
        setPasswordResetMessage(null);
        try {
            await schemas['email'].validate(refEmail.current.value);
            try {
                const res = await (0, $d31d5eedb2e4bc17$export$94a94c25bfe2a6a8)(refEmail.current.value);
                const resJson = await res.json();
                if (resJson?.message) setPasswordResetMessage(resJson.message);
                else setPasswordResetMessage('Could not send password reset email. Try again later.');
                setIsLoading(false);
            } catch (err) {
                setPasswordResetMessage('Could not send password reset email. Try again later.');
                console.warn('Error request password reset email', err);
                setIsLoading(false);
            }
        } catch (err) {
            setCredErrMessage('Enter valid email');
        }
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            isPasswordResetMode ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$Title, {
                text: 'Reset Password'
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: LoginTitleComponent ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(LoginTitleComponent, {}) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$Title, {
                    text: "Log In"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
                className: ` m-0 pt-2`,
                onSubmit: handleSubmit,
                onChange: handleFormChange,
                ref: refForm,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    ref: refFormFieldWrapper,
                    className: "d-flex flex-column gap-4 mb-0",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            class: "d-flex flex-column gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                    htmlFor: "email-input",
                                    className: `block text-sm font-medium mb-0`,
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                    ref: refEmail,
                                    disabled: isLoading,
                                    type: "email",
                                    id: "email-input",
                                    name: "email",
                                    className: `py-2 px-3 block w-full border border-gray-200 ${rounded ? 'rounded-lg' : 'rounded-0'} text-sm
                            
                            disabled:opacity-50 disabled:pointer-events-none`,
                                    placeholder: "you@adweek.com",
                                    onBlur: handleInputFieldValidation
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$InlineInputFieldError, {
                                    target: 'email'
                                })
                            ]
                        }),
                        !isPasswordResetMode && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                usePassword && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    class: "d-flex flex-column gap-2",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                for: "password-input",
                                                className: `block text-sm font-medium mb-0`,
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                ref: refPassword,
                                                disabled: isLoading,
                                                type: "password",
                                                id: "password-input",
                                                name: "password",
                                                className: `py-2 px-3 block w-full border border-gray-200 ${rounded ? 'rounded-lg' : 'rounded-0'} text-sm
                                focus:border-blue-500 focus:ring-blue-500
                                disabled:opacity-50 disabled:pointer-events-none`,
                                                placeholder: "",
                                                onBlur: handleInputFieldValidation
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$InlineInputFieldError, {
                                                target: 'password'
                                            })
                                        ]
                                    })
                                }),
                                credErrMessage && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$ErrorMessage, {
                                    credErrMessage: credErrMessage,
                                    setCredErrMessage: setCredErrMessage
                                }),
                                !usePassword && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: `
                        btn position-relative border border-aw-webinar bg-aw-webinar text-white  ${rounded ? 'rounded-lg' : 'rounded-0'}
                    `,
                                    onClick: ()=>setUsePassword(true),
                                    children: "Use Password"
                                }),
                                usePassword && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$SignInButton, {
                                    isLoading: isLoading,
                                    canLogin: canLogin,
                                    refSubmit: refSubmit,
                                    rounded: rounded
                                }),
                                magicLinkMessage && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$InlineMessage, {
                                    message: magicLinkMessage
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$MagicLinkButton, {
                                    isSendingMagicLink: isSendingMagicLink,
                                    rounded: rounded,
                                    handleMagicLinkRequest: handleMagicLinkRequest,
                                    refEmail: refEmail,
                                    disabled: !canResetPasswordOrMagicLink,
                                    cb: ()=>{
                                        setCredErrMessage(null);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$ForgotPasswordLink, {
                                    startPasswordResetProcess: startPasswordResetProcess,
                                    cb: ()=>{
                                        setMagicLinkMessage(null);
                                        setCredErrMessage(null);
                                    }
                                })
                            ]
                        }),
                        isPasswordResetMode && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                passwordResetMessage && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$InlineMessage, {
                                    message: passwordResetMessage
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$ResetButton, {
                                    isLoading: isLoading,
                                    handlePasswordReset: handlePasswordReset,
                                    disabled: !canResetPasswordOrMagicLink
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: `
                        bg-none border hover:bg-transparent hover:border-black hover:text-black hover:bg-slate-100
                        focus:text-black focus:bg-slate-100
                        ${rounded ? 'rounded-lg' : 'rounded-0'}
                    `,
                                    onClick: ()=>{
                                        setIsPasswordResetMode(false);
                                        setPasswordResetMessage(null);
                                    },
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $4b5ae0f691c28a51$var$MagicLinkButton = ({ isSendingMagicLink: isSendingMagicLink, rounded: rounded, handleMagicLinkRequest: handleMagicLinkRequest, disabled: disabled = false, cb: cb = ()=>{} })=>{
    const ref = $4b5ae0f691c28a51$var$useRef();
    (0, $70a4a67c53cab669$export$e01218ac5c35c80a)(ref);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
        disabled: isSendingMagicLink || disabled,
        className: `
                btn border border-aw-primary hover:border-black hover:text-black hover:bg-slate-100
                focus:text-black focus:bg-slate-100
                ${rounded ? 'rounded-lg' : 'rounded-0'}
                d-flex justify-content-center align-items-center
            `,
        onClick: ()=>{
            handleMagicLinkRequest();
            cb();
        },
        ref: ref,
        style: {
            minHeight: "50px"
        },
        children: isSendingMagicLink ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$LoadingDots, {
            className: 'text-aw-webinar'
        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    className: "d-inline-block mx-1",
                    children: "Send Magic Link"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    fill: "currentColor",
                    className: "bi bi-magic d-inline-block mx-1",
                    viewBox: "0 0 16 16",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                        d: "M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z"
                    })
                })
            ]
        })
    });
};
const $4b5ae0f691c28a51$var$ForgotPasswordLink = ({ startPasswordResetProcess: startPasswordResetProcess, cb: cb })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
        href: "#",
        onClick: (e)=>{
            startPasswordResetProcess(e);
            cb();
        },
        children: "Forgot Password?"
    });
};
const $4b5ae0f691c28a51$var$InlineInputFieldError = ({ target: target })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
        className: "text-danger text-sm m-0",
        "data-field-name": target
    });
};
const $4b5ae0f691c28a51$var$SignInButton = ({ isLoading: isLoading, canLogin: canLogin, refSubmit: refSubmit, rounded: rounded })=>{
    const SignInLoader = ()=>{
        const refLoadingText = React.useRef();
        const refLoadingDots = React.useRef();
        $4b5ae0f691c28a51$var$useEffect(()=>{
            if (typeof anime === 'function') {
                var tl = anime.timeline({
                    opacity: [
                        0,
                        1
                    ],
                    easing: 'easeOutCubic',
                    duration: 500,
                    loop: true,
                    delay: 1000
                });
                tl.add({
                    targets: refLoadingText.current,
                    translateY: [
                        0,
                        -10
                    ],
                    opacity: [
                        1,
                        0
                    ]
                }).add({
                    targets: refLoadingDots.current,
                    translateY: [
                        10,
                        0
                    ],
                    opacity: [
                        0,
                        1
                    ],
                    duration: 200,
                    delay: 1200
                }, '-=1500').add({
                    targets: refLoadingDots.current,
                    translateY: [
                        0,
                        -10
                    ],
                    opacity: [
                        1,
                        0
                    ]
                }).add({
                    targets: refLoadingText.current,
                    translateY: [
                        10,
                        0
                    ],
                    opacity: [
                        0,
                        1
                    ],
                    duration: 200,
                    delay: 1200
                }, '-=1500');
            }
        }, []);
        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    ref: refLoadingText,
                    children: "Signing in"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    ref: refLoadingDots,
                    className: "position-absolute mt-n2 la-ball-pulse la-dark la-sm",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {}),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {})
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
        type: "submit",
        ref: refSubmit,
        disabled: isLoading || !canLogin,
        className: `
                btn position-relative border border-aw-webinar bg-aw-webinar text-white  ${rounded ? 'rounded-lg' : 'rounded-0'}
            `,
        children: isLoading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            className: "d-flex flex-column position-relative justify-content-center align-items-center",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(SignInLoader, {})
        }) : 'Sign In'
    });
};
const $4b5ae0f691c28a51$var$ErrorMessage = ({ credErrMessage: credErrMessage, setCredErrMessage: setCredErrMessage })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "alert alert-warning rounded-0 py-1 px-3 mb-0 text-sm d-flex justify-content-between align-items-center",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                children: credErrMessage
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                className: "bi bi-x-lg",
                viewBox: "0 0 16 16",
                onClick: (e)=>setCredErrMessage(null),
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                    d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
                })
            })
        ]
    });
};
const $4b5ae0f691c28a51$var$Title = ({ text: text })=>{
    const ref = $4b5ae0f691c28a51$var$useRef();
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h4", {
        ref: ref,
        className: " text-2xl font-semibold mb-3 ",
        children: text
    });
};
const $4b5ae0f691c28a51$var$ResetButton = ({ handlePasswordReset: handlePasswordReset, isLoading: isLoading, disabled: disabled = false, cb: cb = ()=>{} })=>{
    const refButton = React.useRef();
    (0, $70a4a67c53cab669$export$e01218ac5c35c80a)(refButton);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
        disabled: isLoading || disabled,
        className: "position-relative border border-aw-webinar bg-aw-webinar text-white rounded-0 d-flex justify-content-center align-items-center",
        onClick: ()=>{
            handlePasswordReset();
            cb();
        },
        ref: refButton,
        children: isLoading ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($4b5ae0f691c28a51$var$LoadingDots, {}) : "Reset"
    });
};
const $4b5ae0f691c28a51$var$LoadingDots = ({ className: className })=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: `position-absolute mt-n2 la-ball-pulse la-dark la-sm ${className}`,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {})
        ]
    });
const $4b5ae0f691c28a51$var$InlineMessage = ({ message: message })=>{
    const ref = React.useRef();
    $4b5ae0f691c28a51$var$useEffect(()=>{
        if (typeof anime === 'function' && ref?.current) anime({
            targets: ref.current,
            opacity: [
                0,
                1
            ],
            translateX: [
                10,
                0
            ]
        });
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
        ref: ref,
        className: "text-sm m-0 d-inline-block mb-0",
        dangerouslySetInnerHTML: {
            __html: message
        }
    });
};




const $29dcc6f537bdb223$var$React = window.React;
function $29dcc6f537bdb223$var$LoginPrompt() {
    const ref = $29dcc6f537bdb223$var$React.useRef();
    const refLoginForm = $29dcc6f537bdb223$var$React.useRef();
    const [isLoading, setIsLoading] = $29dcc6f537bdb223$var$React.useState(false);
    function handleDisplay(mount = true) {
        // Dismiss the tooltip if its open
        $('#login-prompt-tooltip').tooltip('hide');
        if (mount) {
            ref.current.parentElement.classList.remove('d-none');
            ref.current.parentElement.classList.add('d-flex');
            animateLoginPrompt(mount);
        } else {
            setIsLoading(false);
            animateLoginPrompt(mount).then(()=>{
                ref.current.parentElement.classList.remove('d-flex');
                ref.current.parentElement.classList.add('d-none');
            });
        }
    }
    const animateLoginPrompt = (mount)=>{
        return new Promise((resolve, reject)=>{
            if (typeof anime === 'function') {
                anime({
                    targets: ref.current,
                    opacity: [
                        mount ? 0 : 1,
                        mount ? 1 : 0
                    ],
                    duration: 250,
                    easing: 'easeOutQuad'
                });
                anime({
                    targets: refLoginForm.current,
                    opacity: [
                        mount ? 0 : 1,
                        mount ? 1 : 0
                    ],
                    translateY: [
                        mount ? 20 : 0,
                        mount ? 0 : 20
                    ],
                    duration: 250,
                    easing: 'easeOutQuad',
                    complete: ()=>{
                        resolve();
                    }
                });
            } else resolve();
        });
    };
    $29dcc6f537bdb223$var$React.useEffect(()=>{
        window.setLoginFormDisplay = handleDisplay;
        document.dispatchEvent(new Event('adwLoginComponentLoaded'));
    }, []);
    const LoginTitle = ()=>{
        const ref = $29dcc6f537bdb223$var$React.useRef();
        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h4", {
                    className: " text-2xl font-semibold mb-3 ",
                    children: "Sign In"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                    children: "Already an Adweek member? Register faster by signing in and enabling autofill."
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        ref: ref,
        className: "",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: " w-100 h-100 position-absolute top-0 end-0 start-0 bottom-0",
                    style: {
                        background: 'var(--bs-body-bg)',
                        opacity: .7
                    },
                    onClick: ()=>handleDisplay(false)
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    ref: refLoginForm,
                    className: "login-prompt position-relative overflow-hidden my-8 mx-4 shadow-lg relative rounded-lg border",
                    style: {
                        background: 'var(--bs-body-bg)'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "btn dismiss-login-prompt position-absolute end-0 d-flex justify-content-center align-items-center p-2 border-0 ",
                            onClick: ()=>handleDisplay(false),
                            type: "button",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                className: "bi bi-x-lg",
                                viewBox: "0 0 16 16",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                    d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: " p-4 md:p-8",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4b5ae0f691c28a51$export$1f58f750f20f344b), {
                                LoginTitleComponent: LoginTitle,
                                isLoading: isLoading,
                                setIsLoading: setIsLoading,
                                rounded: false,
                                dismissCbFn: ()=>handleDisplay(false),
                                successCbFn: typeof initConvertrFormForWebinar !== 'undefined' ? initConvertrFormForWebinar : null
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $29dcc6f537bdb223$export$2e2bcd8739ae039 = $29dcc6f537bdb223$var$LoginPrompt;


function $8e611385945267a0$var$loadFrontendScripts() {
    (0, $ba887f0904e69114$export$2e2bcd8739ae039)();
    $8e611385945267a0$var$initFEComponents();
}
/**
 * @param {AbortSignal} signal
 */ function $8e611385945267a0$var$addLoginButtonClickListener(signal) {
    const elLoginBtn = document.querySelector('.btn-signin');
    if (!elLoginBtn) return;
    elLoginBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.setLoginFormDisplay(true);
    }, {
        signal: signal
    });
}
function $8e611385945267a0$var$initFEComponents() {
    const controller = new AbortController();
    const { signal: signal } = controller;
    document.addEventListener('DOMContentLoaded', function() {
        document.components = {
            LoginForm: (0, $4b5ae0f691c28a51$export$1f58f750f20f344b)
        };
        document.dispatchEvent(new Event('adwComponentsLoaded'));
        $8e611385945267a0$var$addLoginButtonClickListener();
        const elModalContainer = document.getElementById('modal-for-webinar');
        const elPage = document.getElementById('page');
        if (elPage) {
            const ReactDOM = window.ReactDOM;
            elPage.insertAdjacentElement('beforeend', elModalContainer);
            const root = ReactDOM.client.createRoot(elModalContainer);
            console.log('ReactDOM.client version: ', ReactDOM.client.version);
            console.log('React version: ', React.version);
            root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $29dcc6f537bdb223$export$2e2bcd8739ae039), {}));
        }
    }, {
        once: true,
        signal: signal
    });
}
$8e611385945267a0$var$loadFrontendScripts();

})();
//# sourceMappingURL=scripts.js.map
